"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../helpers");
const Text_1 = require("../../../Text");
exports.StyledText = (0, styled_components_1.default)(Text_1.Text) `
    &[data-toolbar-text='true']:nth-child(n + 2) {
        margin-left: ${helpers_1.SIZE_M};
    }
    &[data-toolbar-text='true'] + * {
        margin-left: ${helpers_1.SIZE_M};
    }
`;
//# sourceMappingURL=Text.styles.js.map